import { getEndpoint } from "@api-routes/endpoint";

const PAYMENTS_MS_NAME = "payments";

export const updateExpiryDateCardRoute = (cardId: number, accountId: string) =>
    `${getEndpoint(PAYMENTS_MS_NAME)}payer/${accountId}/card_payment_method/${cardId}/update_expiry_date`;

export const getPaymentDetailsRoute = (paymentCorrelationTransactionUuid: string) =>
    `${getEndpoint(PAYMENTS_MS_NAME)}payment/${paymentCorrelationTransactionUuid}`;

export const payerRoute = (accountId: string) => `${getEndpoint(PAYMENTS_MS_NAME)}payer/${accountId}`;

export const updateDefaultPaymentMethodRoute = (cardId: number, accountId: string) =>
    `${getEndpoint(PAYMENTS_MS_NAME)}payer/${accountId}/default_payment_method/${cardId}`;

export const removePaymentCardRoute = (cardId: number, accountId: string) =>
    `${getEndpoint(PAYMENTS_MS_NAME)}payer/${accountId}/payment_method/${cardId}`;
